var Division, cllCookie, decodeAddress, geoStorageKey, getFullAddressFromSearchLocCookie, getGeolocationData, getInitialGeolocationAddress, getInitialLocation, getInitialLocationData, getSearchLocCookie, getTranslations, getUserSearchLocData, presentAddress, removeGeolocationData, setELLCookie, setGeolocationData, setSearchLocCookie, userFriendlyLocation,
  slice = [].slice;

getTranslations = require('./m_typeahead_helper').getTranslations;

geoStorageKey = 'LS_geolocation';

Division = (function(currentDivision) {
  return {
    get: function() {
      return currentDivision;
    },
    set: function(division) {
      return currentDivision = division;
    }
  };
})(null);


/*
 * Get decoded address
 *
 * @param   {String} [address] - Encoded address string
 * @returns {String}           - Key value or empty object
 */

decodeAddress = function(address) {
  if (address == null) {
    address = '';
  }
  return decodeURIComponent(address).replace(/\+/g, ' ');
};


/*
 * Retrieve geolocation data from localStorage
 *
 * @param   {String}        [key] - Key name (optional)
 * @returns {String|Object} data  - Geodata object or specific data
 */

getGeolocationData = function(key) {
  var data, ref;
  try {
    if ((data = (ref = window.localStorage) != null ? ref.getItem(geoStorageKey) : void 0) != null) {
      data = JSON.parse(data);
      if (typeof key === 'string') {
        data = data[key];
      }
    }
  } catch (error) {}
  return data || {};
};


/*
 * Retrieve location name from various sources
 *
 * @returns {String} location - Location name or empty string
 */

getInitialLocation = function() {
  var division, divisionData, location;
  divisionData = Division != null ? Division.get() : void 0;
  division = divisionData != null ? divisionData.id : void 0;
  if ((location = getInitialGeolocationAddress(division))) {
    return location;
  }
  if ((location = getFullAddressFromSearchLocCookie())) {
    return location;
  }
  if ((location = userFriendlyLocation(divisionData))) {
    return location;
  }
  return '';
};


/*
 * Get location data
 *
 * @returns {Object} latLong - Location object
 */

getInitialLocationData = function() {
  var geoData, grab, latLong, locationData, queryParams;
  grab = function() {
    var data, i, j, len, properties, source, sources;
    sources = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), properties = arguments[i++];
    for (j = 0, len = sources.length; j < len; j++) {
      source = sources[j];
      data = _.pick(source || {}, properties);
      if (!_.isEmpty(data)) {
        break;
      }
    }
    return data;
  };
  queryParams = Groupon.Utils.unparam();
  locationData = getUserSearchLocData();
  latLong = grab(queryParams, locationData, Division.get(), ['lat', 'lng']);
  geoData = grab(queryParams, locationData, ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  return latLong = _.extend(latLong, geoData);
};


/*
 * Get "search_loc" cookie data
 *
 * @returns {Object} - search_loc - Search_loc data
 */

getSearchLocCookie = function() {
  var e, payload, search_loc;
  search_loc = {};
  if ((payload = Cookie.get('search_loc')) != null) {
    try {
      search_loc = JSON.parse(decodeURIComponent(payload));
    } catch (error) {
      e = error;
      try {
        search_loc = decodeURIComponent(JSON.parse(payload));
      } catch (error) {}
    }
  }
  return search_loc;
};


/*
 * Retrieve address from "search_loc" cookie
 *
 * @returns {String} - Address or empty string
 */

getFullAddressFromSearchLocCookie = function() {
  var friendlyName, fullAddress, ref;
  ref = getSearchLocCookie(), fullAddress = ref.fullAddress, friendlyName = ref.friendlyName;
  return decodeAddress(fullAddress) || decodeAddress(friendlyName);
};


/*
 * Retrieve data from "search_loc" cookie
 *
 * @returns {Object} - Relevant location data
 */

getUserSearchLocData = function() {
  var search_loc;
  search_loc = getSearchLocCookie();
  return _.pick(search_loc, ['lat', 'lng', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/*
 * Returns current location label if division match current location division
 *
 * @param   {String} division - Division from itier division data
 * @returns {String} label    - Current location label or undefined
 */

getInitialGeolocationAddress = function(division) {
  var label, ref;
  label = '';
  if (division && division === getGeolocationData('current_location')['closestDivision']) {
    label = (ref = getTranslations('search')) != null ? ref.nearme : void 0;
  }
  return label;
};


/*
 * Changes address to remove duplicate address sections and country "USA"
 *
 * @param   {String} address - Address returned by Google Maps
 * @returns {String}         - Formatted address
 */

presentAddress = function(address) {
  var splitAddress;
  address = address.replace(/, USA$/, '');
  splitAddress = address.split(', ');
  return _.uniq(splitAddress, true).join(', ');
};


/*
 * Removes geolocation key from localStorage / cookie
 *
 * @param {String} key - LocalStorage key name
 */

removeGeolocationData = function(key) {
  var data, ref;
  if (key != null) {
    data = getGeolocationData();
    delete data[key];
    data = JSON.stringify(data);
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, data);
      }
    } catch (error) {
      Cookie.set(geoStorageKey, encodeURIComponent(data));
    }
  }
};


/*
 * LS-2274 Set new location cookie "ell"
 *
 * @param {String} data - String contain <lat>,<lng>
 */

setELLCookie = function(data) {
  Cookie.set('ell', data);
};


/*
 * LS-2273 current location cookie "cll"
 */

cllCookie = {

  /*
   * LS-2273 Set new current location cookie "cll"
   *
   * @param {Object} location - Object containing coordinates
   */
  set: function(location) {
    var lat, lng, ref;
    if (!(location != null ? location.coords : void 0)) {
      return;
    }
    ref = location.coords, lat = ref.latitude, lng = ref.longitude;
    Cookie.set('cll', lat + ',' + lng);
  },

  /*
   * LS-2273 remove current location cookie "cll"
   */
  remove: function() {
    return Cookie.unset('cll');
  }
};


/*
 * Sets geolocation key/value pair to localStorage / cookie
 *
 * @param {String} key   - LocalStorage key name
 * @param {String} value - Value to be set
 */

setGeolocationData = function(key, value) {
  var data, ref;
  if ((key != null) && (value != null)) {
    data = getGeolocationData();
    data[key] = value;
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, JSON.stringify(data));
      }
    } catch (error) {}
  }
};


/*
 * Sets "search_loc" cookie storing various data gathered from Gmaps and API responses
 *
 * @param {Object} data - Location data object
 */

setSearchLocCookie = function(data) {
  data = _.pick(data, ['lat', 'lng', 'closestDivision', 'friendlyName', 'fullAddress', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  Cookie.set('search_loc', encodeURIComponent(JSON.stringify(data)));
};


/*
 * Returns Division Name
 *
 * @param   {Object} division - Division from itier division data
 * @returns {String} name     - Division name
 */

userFriendlyLocation = function(division) {
  var abbreviation, name, state;
  if (!(division != null ? division.name : void 0)) {
    return '';
  }
  name = division.name, state = division.state;
  if (abbreviation = state != null ? state.abbreviation : void 0) {
    name = name + ", " + abbreviation;
  }
  return name;
};

module.exports = {
  cllCookie: cllCookie,
  decodeAddress: decodeAddress,
  getDivision: Division.get,
  getGeolocationData: getGeolocationData,
  getFullAddressFromSearchLocCookie: getFullAddressFromSearchLocCookie,
  getInitialGeolocationAddress: getInitialGeolocationAddress,
  getInitialLocation: getInitialLocation,
  getInitialLocationData: getInitialLocationData,
  getSearchLocCookie: getSearchLocCookie,
  getUserSearchLocData: getUserSearchLocData,
  presentAddress: presentAddress,
  removeGeolocationData: removeGeolocationData,
  setELLCookie: setELLCookie,
  setDivision: Division.set,
  setGeolocationData: setGeolocationData,
  setSearchLocCookie: setSearchLocCookie,
  userFriendlyLocation: userFriendlyLocation
};

//# sourceMappingURL=data:application/json;base64,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
